var Division, cllCookie, decodeAddress, geoStorageKey, getFullAddressFromSearchLocCookie, getGeolocationData, getInitialGeolocationAddress, getInitialLocation, getInitialLocationData, getSearchLocCookie, getTranslations, getUserSearchLocData, presentAddress, removeGeolocationData, setELLCookie, setGeolocationData, setSearchLocCookie, userFriendlyLocation,
  slice = [].slice;

getTranslations = require('./m_typeahead_helper').getTranslations;

geoStorageKey = 'LS_geolocation';

Division = (function(currentDivision) {
  return {
    get: function() {
      return currentDivision;
    },
    set: function(division) {
      return currentDivision = division;
    }
  };
})(null);


/*
 * Get decoded address
 *
 * @param   {String} [address] - Encoded address string
 * @returns {String}           - Key value or empty object
 */

decodeAddress = function(address) {
  if (address == null) {
    address = '';
  }
  return decodeURIComponent(address).replace(/\+/g, ' ');
};


/*
 * Retrieve geolocation data from localStorage
 *
 * @param   {String}        [key] - Key name (optional)
 * @returns {String|Object} data  - Geodata object or specific data
 */

getGeolocationData = function(key) {
  var data, ref;
  try {
    if ((data = (ref = window.localStorage) != null ? ref.getItem(geoStorageKey) : void 0) != null) {
      data = JSON.parse(data);
      if (typeof key === 'string') {
        data = data[key];
      }
    }
  } catch (error) {}
  return data || {};
};


/*
 * Retrieve location name from various sources
 *
 * @returns {String} location - Location name or empty string
 */

getInitialLocation = function() {
  var division, divisionData, location;
  divisionData = Division != null ? Division.get() : void 0;
  division = divisionData != null ? divisionData.id : void 0;
  if ((location = getInitialGeolocationAddress(division))) {
    return location;
  }
  if ((location = getFullAddressFromSearchLocCookie())) {
    return location;
  }
  if ((location = userFriendlyLocation(divisionData))) {
    return location;
  }
  return '';
};


/*
 * Get location data
 *
 * @returns {Object} latLong - Location object
 */

getInitialLocationData = function() {
  var geoData, grab, latLong, locationData, queryParams;
  grab = function() {
    var data, i, j, len, properties, source, sources;
    sources = 2 <= arguments.length ? slice.call(arguments, 0, i = arguments.length - 1) : (i = 0, []), properties = arguments[i++];
    for (j = 0, len = sources.length; j < len; j++) {
      source = sources[j];
      data = _.pick(source || {}, properties);
      if (!_.isEmpty(data)) {
        break;
      }
    }
    return data;
  };
  queryParams = Groupon.Utils.unparam();
  locationData = getUserSearchLocData();
  latLong = grab(queryParams, locationData, Division.get(), ['lat', 'lng']);
  geoData = grab(queryParams, locationData, ['administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  return latLong = _.extend(latLong, geoData);
};


/*
 * Get "search_loc" cookie data
 *
 * @returns {Object} - search_loc - Search_loc data
 */

getSearchLocCookie = function() {
  var e, payload, search_loc;
  search_loc = {};
  if ((payload = Cookie.get('search_loc')) != null) {
    try {
      search_loc = JSON.parse(decodeURIComponent(payload));
    } catch (error) {
      e = error;
      try {
        search_loc = decodeURIComponent(JSON.parse(payload));
      } catch (error) {}
    }
  }
  return search_loc;
};


/*
 * Retrieve address from "search_loc" cookie
 *
 * @returns {String} - Address or empty string
 */

getFullAddressFromSearchLocCookie = function() {
  var friendlyName, fullAddress, ref;
  ref = getSearchLocCookie(), fullAddress = ref.fullAddress, friendlyName = ref.friendlyName;
  return decodeAddress(fullAddress) || decodeAddress(friendlyName);
};


/*
 * Retrieve data from "search_loc" cookie
 *
 * @returns {Object} - Relevant location data
 */

getUserSearchLocData = function() {
  var search_loc;
  search_loc = getSearchLocCookie();
  return _.pick(search_loc, ['lat', 'lng', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
};


/*
 * Returns current location label if division match current location division
 *
 * @param   {String} division - Division from itier division data
 * @returns {String} label    - Current location label or undefined
 */

getInitialGeolocationAddress = function(division) {
  var label, ref;
  label = '';
  if (division && division === getGeolocationData('current_location')['closestDivision']) {
    label = (ref = getTranslations('search')) != null ? ref.nearme : void 0;
  }
  return label;
};


/*
 * Changes address to remove duplicate address sections and country "USA"
 *
 * @param   {String} address - Address returned by Google Maps
 * @returns {String}         - Formatted address
 */

presentAddress = function(address) {
  var splitAddress;
  address = address.replace(/, USA$/, '');
  splitAddress = address.split(', ');
  return _.uniq(splitAddress, true).join(', ');
};


/*
 * Removes geolocation key from localStorage / cookie
 *
 * @param {String} key - LocalStorage key name
 */

removeGeolocationData = function(key) {
  var data, ref;
  if (key != null) {
    data = getGeolocationData();
    delete data[key];
    data = JSON.stringify(data);
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, data);
      }
    } catch (error) {
      Cookie.set(geoStorageKey, encodeURIComponent(data));
    }
  }
};


/*
 * LS-2274 Set new location cookie "ell"
 *
 * @param {String} data - String contain <lat>,<lng>
 */

setELLCookie = function(data) {
  Cookie.set('ell', data);
};


/*
 * LS-2273 current location cookie "cll"
 */

cllCookie = {

  /*
   * LS-2273 Set new current location cookie "cll"
   *
   * @param {Object} location - Object containing coordinates
   */
  set: function(location) {
    var lat, lng, ref;
    if (!(location != null ? location.coords : void 0)) {
      return;
    }
    ref = location.coords, lat = ref.latitude, lng = ref.longitude;
    Cookie.set('cll', lat + ',' + lng);
  },

  /*
   * LS-2273 remove current location cookie "cll"
   */
  remove: function() {
    return Cookie.unset('cll');
  }
};


/*
 * Sets geolocation key/value pair to localStorage / cookie
 *
 * @param {String} key   - LocalStorage key name
 * @param {String} value - Value to be set
 */

setGeolocationData = function(key, value) {
  var data, ref;
  if ((key != null) && (value != null)) {
    data = getGeolocationData();
    data[key] = value;
    try {
      if ((ref = window.localStorage) != null) {
        ref.setItem(geoStorageKey, JSON.stringify(data));
      }
    } catch (error) {}
  }
};


/*
 * Sets "search_loc" cookie storing various data gathered from Gmaps and API responses
 *
 * @param {Object} data - Location data object
 */

setSearchLocCookie = function(data) {
  data = _.pick(data, ['lat', 'lng', 'closestDivision', 'friendlyName', 'fullAddress', 'administrative_area', 'locality', 'sublocality', 'neighborhood', 'postal_code']);
  Cookie.set('search_loc', encodeURIComponent(JSON.stringify(data)));
};


/*
 * Returns Division Name
 *
 * @param   {Object} division - Division from itier division data
 * @returns {String} name     - Division name
 */

userFriendlyLocation = function(division) {
  var abbreviation, name, state;
  if (!(division != null ? division.name : void 0)) {
    return '';
  }
  name = division.name, state = division.state;
  if (abbreviation = state != null ? state.abbreviation : void 0) {
    name = name + ", " + abbreviation;
  }
  return name;
};

module.exports = {
  cllCookie: cllCookie,
  decodeAddress: decodeAddress,
  getDivision: Division.get,
  getGeolocationData: getGeolocationData,
  getFullAddressFromSearchLocCookie: getFullAddressFromSearchLocCookie,
  getInitialGeolocationAddress: getInitialGeolocationAddress,
  getInitialLocation: getInitialLocation,
  getInitialLocationData: getInitialLocationData,
  getSearchLocCookie: getSearchLocCookie,
  getUserSearchLocData: getUserSearchLocData,
  presentAddress: presentAddress,
  removeGeolocationData: removeGeolocationData,
  setELLCookie: setELLCookie,
  setDivision: Division.set,
  setGeolocationData: setGeolocationData,
  setSearchLocCookie: setSearchLocCookie,
  userFriendlyLocation: userFriendlyLocation
};

//# sourceMappingURL=data:application/json;base64,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
